import React from "react";
import { Link } from "react-router-dom";

export const PriceSection = ({ payload }) => {
  return (
    <section>
      {payload?.map((item, index) => {
        return (
          <div className="feature-section" key={index}>
            <div className="sport-item premium-item">
              <div className="premium-item-benifit">
                <div className="sport-item-title">{item.title}</div>
                <p className="text-left">{item.details}</p>
                <Link className="white" id="reqdemo" to="/pricing">
                  <button
                    type="button"
                    className="request-btn fs-28 bold hero-section-button integration-content-button text-light"
                  >
                    View detailed Plans
                  </button>
                </Link>
              </div>
            </div>
            <div className="sport-item premium-item premium-section ">
              <div className="premium-item-benifit">
                <div className="p-3">
                  <div className="item-benifit-title">Get Premium</div>
                  <div className="item-benifit-header">Benefits of Premium</div>
                  <ul className="item-benifit-list">
                    <li>Live Game Analysis</li>
                    <li>Video Analysis</li>
                    <li>Video Playlist Editor</li>
                  </ul>
                </div>
                <div className="item-benifit-tile-container">
                  <div className="benifit-tile first-tile">
                    <div>Free for 2 weeks</div>
                  </div>
                  <div className="benifit-tile second-tile">
                    <div>Regular</div>
                    <div>&#36; 1000</div>
                    <div>/ Year</div>
                  </div>
                  <div className="benifit-tile third-tile">
                    <div>MOST POPULAR</div>
                    <div>&#36; 2000</div>
                    <div>/ Year</div>
                    <div className="tile-ribbon">
                      10% <br /> off
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </section>
  );
};
